// import { useState, useEffect } from 'react'
// import Tabs from '../../../../Components/Tabs'
// import { useLocation, useNavigate } from 'react-router-dom'
// import Tab1 from './Tab1'
// import Tab2 from './Tab2'
// import Tab4 from './Tab4'
// import Table from './Table'
// import GetIcon from '../../../../utils/Icon'
// import Button from '../../../../Core/Button/Button'
// import { useCreateDeliveryNotePicklistMutation, useSubmitDeliveryNoteMutation,
//      useLazyGetDeliveryNoteDocQuery } from '../../../../store/api/deliveryNoteApi'
// import ApiResponseBox from '../../../../Components/ApiResponseBox'
// import { useLazyGetPicklistDetailsQuery } from '../../../../store/api/picklist'
// import Tab5 from './Tab5'
// import Attachment from '../../../../utils/Attachment'
// import { usePostPurchaseOrderIDMutation } from '../../../../store/api/purchaseorderapi'
// import EditDeliverynote from '../Edit-delivery-note/Deliverynote'
// function Deliverynote() {

//     const location = useLocation();
//     console.log("check navigation",location);
//     const nvg = useNavigate()
//     const [picklist_id, setpicklist_id] = useState(location?.state?.picklist_id ? location?.state?.picklist_id : '' )
//     const [is_new, setis_new] = useState(location?.state?.is_new ? location?.state?.is_new : '')
//     const [buttonData, setButtonData] = useState(false)
//     const [errorr, setError] = useState('');
//     const [ptype, setptype] = useState("Error ");
//     const [showError, setShowError] = useState(false);
//     const [submitboll, setsubmitboll] = useState(false);

//     const [tab, settab] = useState(1)
//     const [deliveryNoteData, setDeliveryNoteData] = useState(null);
//     const [deliveryNoteItems, setDeliveryNoteItems] = useState([]);
//     const [deliveryNoteId, sedeliveryNoteId] = useState(null);
    
//         const [postdeliverydate, setpostdeliverydate] = useState('');
//         const [postdeliverytime, setpostdeliverytime] = useState('');
//         const [postcheckbox, setpostcheckbox] = useState(false);

//     console.log("deliverynote id is ehre",deliveryNoteId);
//     const [shipmentItems, setshipmentItems] = useState([]);
//     const [activityboll, setactivityboll] = useState(false);

//     const [selectedpicklist, setselectedpicklist] = useState(location?.state?.picklist_id ? location?.state?.picklist_id : '');
//     const [picklist, setpicklist] = useState([]);
//     const [getAllPick] = usePostPurchaseOrderIDMutation();



//     // test pick call here
//     const [trigger] = useLazyGetPicklistDetailsQuery();

//     const pickListdetail = async (picklist_id) => {
//         try {
//             const result = await trigger({ doctype: 'Pick List', name: picklist_id }).unwrap();
//             console.log(result, "result_came_test");

//             setDeliveryNoteItems(result?.message?.locations || []);
//             setDeliveryNoteData(result);
//         } catch (err) {
//             console.error("Error fetching picklist details:", err);
//         }
//     };

//     // useEffect(() => {
//     //     const idFromLocalStorage = localStorage.getItem("deliveryNoteId");
//     //     if (idFromLocalStorage != null) {
//     //         console.log("yes_local");
//     //         sedeliveryNoteId(idFromLocalStorage);
//     //     }
//     // }, [is_new]);

//     useEffect(() => {
//         console.log(picklist_id, "picklist_id");

//         if (picklist_id && !deliveryNoteId) {
//             pickListdetail(picklist_id);
//         }
//     }, [picklist_id]);



//     const idFromLocalStorage = localStorage.getItem("deliveryNoteId");
//     // const idToUse = deliveryNoteId || idFromLocalStorage;

//     // const [triggerDeliveryNote, {
//     //     data: deliveryNoteResponse,
//     //     isError,
//     //     error
//     // }] = useLazyGetDeliveryNoteDocQuery();

//     // useEffect(() => {
//     //     if (idToUse) {
//     //         triggerDeliveryNote(idToUse);
//     //     }
//     // }, [idToUse, submitboll]);

//     // useEffect(() => {
//     //     if (deliveryNoteResponse?.docs?.[0]) {
//     //         const fullDoc = deliveryNoteResponse.docs[0];
//     //         const { items, ...rest } = fullDoc;
//     //         setshipmentItems(fullDoc.custom_shipment_references || [])

//     //         setDeliveryNoteItems(items || []);
//     //         setDeliveryNoteData(rest);
//     //     }

//     //     if (isError) {
//     //         alert(error);
//     //     }
//     // }, [deliveryNoteResponse, isError, error, submitboll]);

//     useEffect(()=>{
//        if(selectedpicklist){
//         setpicklist_id(selectedpicklist);
//         setis_new(true);
//        }else{
//         setDeliveryNoteData(null);
//         setDeliveryNoteItems([]);
//         setpicklist_id('');
//         sedeliveryNoteId(null)
//         setshipmentItems([])
//         setis_new(true);
//        }
//     },[selectedpicklist])


//             console.log("checkk api response is eh4 is localstroage i ehr",localStorage.getItem("deliveryNoteId"));





//     const [createDeliveryNoteApi] = useCreateDeliveryNotePicklistMutation();
//     const CreateDelivaryNote = async () => {
//         try {
//              if(postcheckbox == true && postdeliverytime != "" && postdeliverydate != ""){
//                 let apidata={
//                     postdeliverydate:postdeliverydate,
//                     postdeliverytime:postdeliverytime,
//                     postcheckbox:postcheckbox,
//                     picklist_id:picklist_id
//                 }
//              }
//             const response = await createDeliveryNoteApi(picklist_id).unwrap();
//             console.log("checkk api response is eh4",response);
//             const delivery_note_id = response.result.delivery_note_id
//             // localStorage.removeItem("deliveryNoteId");
//              localStorage.setItem("deliveryNoteId", response.result.delivery_note_id);
//             sedeliveryNoteId(delivery_note_id)
//             setError('Created');
//             setptype('Delivery Note Created successfully:');
//             setShowError(true);

//         } catch (error) {
//             setError('Failed to create Delivery Note:', error);
//             setptype('Error');
//             setShowError(true);
//         }
//     };

//     const [submitDeliveryNote] = useSubmitDeliveryNoteMutation();
//     const handleSubmit = async () => {
//         const idFromLocalStorage = localStorage.getItem("deliveryNoteId");
//         const idToSubmit = deliveryNoteId || idFromLocalStorage;

//         if (!idToSubmit) {
//             console.error("❌ No delivery note ID found.");
//             return;
//         }

//         try {
//             const result = await submitDeliveryNote(idToSubmit).unwrap();
//             setError('Submited');
//             setptype('Delivery Note submitted successfully:');
//             setShowError(true);
//             setsubmitboll(true)
//             setactivityboll(prev => !prev);
//             sedeliveryNoteId(idToSubmit)
//             localStorage.removeItem("deliveryNoteId");
//             // setTimeout(() => {
//             //     nvg('/outbound/outbound-delivery-note')
//             // }, 2000);
//             // if (!deliveryNoteId && idFromLocalStorage) {
//             //     localStorage.removeItem("deliveryNoteId");
//             // }
//         } catch (err) {
//             console.error('❌ Failed to submit Delivery Note:', err);
//             if(err.data.message){
//                 setptype("Error")
//                 setError(err.data.message);
//                 setShowError(true);
//             }
//         }
//     };


//     const totalPickedQty = deliveryNoteItems.reduce((total, item) => total + (item.picked_qty || 0), 0);

//     const Sales_Invoice_Navigation = () => {
//         if (deliveryNoteId) {
//             nvg("/outbound/outbound/create-sales-invoice/", {
//                 state: { deliveryNoteId },
//             });
//         } else {
//             console.error("❌ No deliveryNoteId to send.");
//         }
//     };

//     const Packing_Slip_Navigation = async () => {
//         console.log(deliveryNoteId, "deliveryNoteId");


//         if (!deliveryNoteId) {
//             console.error("No delivery note ID available");
//             return;
//         }

//         // Set deliveryNoteId in localStorage
//         localStorage.setItem("deliveryNoteId", deliveryNoteId);

//         // Navigate with the deliveryNoteId in state
//         nvg("/outbound/outbound-create-packingslip", {
//             state: { deliveryNoteId: deliveryNoteId }
//         });
//     };

//     //   GET all Pick List Data 
//       useEffect(()=>{
//        const getpicklistfun = async () =>{

//          const formData = new FormData();
//          formData.append("doctype", "Pick List");
//          formData.append("fields", JSON.stringify(["name"]));
//          formData.append("filters", JSON.stringify([["Pick List","status","=","Open"],["Pick List","pick_status_st","is","not set"]]));
//          formData.append("order_by", "modified desc");
//          formData.append("view", "List");
//          formData.append("start",0);
//          formData.append("view",9999999);

//          const getpo = await getAllPick(formData);
//         const names = getpo?.data?.message?.values.map((item) => ({ name: item[0] }));
//          setpicklist(names)
//         }

//         getpicklistfun();
//       },[])

//     return (
//         deliveryNoteId != null ? <div className="container-fluid maindiv d-flex flex-column " style={{flexGrow:'1'}}>
//          <EditDeliverynote deliveryNoteId={deliveryNoteId} name="New Delivery Note" /> </div> : <>
//             <Tabs />
//             <div className="d-flex justify-content-between p-2 " style={{ background: "#fcfdfe", height: '40px' }}>
//                 <div className="d-flex align-items-center customizewidth">
//                     <p className="m-0 breadcrumb-item">Outbound</p>
//                     <p className="m-0"> <GetIcon iconName="MdOutlineKeyboardArrowRight" size={13} /> </p>
//                     <p className="m-0 breadcrumb-item" style={{ cursor: 'pointer' }} onClick={() => nvg('/outbound/outbound-delivery-note')}>Delivery Note List </p>
//                     <p className="m-0">  <GetIcon iconName="MdOutlineKeyboardArrowRight" size={13} />  </p>
//                     <a href="javascript:void(0);" className="pagetitle d-flex align-items-center mainpage" style={{ borderBottom: "0px solid", textWrap: "nowrap", gap: '5px', color: "#270B79" }} >
//                         New Delivery Note
//                         {deliveryNoteData?.status && (
//                             <button
//                                 className={` ${buttonData
//                                     ? 'rounded-pill newdesign123'
//                                     : 'rounded-pill newdesign2343'
//                                     }`}
//                             >
//                                 {deliveryNoteData.status}
//                             </button>
//                         )}
//                     </a>
//                 </div>
//                 <div className="d-flex align-items-center justify-content-end customizewidth" style={{ gap: '5px' }} >
//                     {(deliveryNoteData?.status === 'Draft' && deliveryNoteId) && deliveryNoteData?.doctype !== 'Pick List' && (
//                         <Button
//                             style={{ gap: '2px', background: '#391F84' }}
//                             className="createbtn"
//                             iconName="FaPlus"
//                             iconSize={14}
//                             onClick={Packing_Slip_Navigation}
//                         >
//                             Packing Slip
//                         </Button>
//                     )}



//                     {submitboll && (
//                         <Button
//                             style={{ gap: '2px' }}
//                             className="createbtn"
//                             iconName="FaPlus"
//                             iconSize={12}
//                             onClick={Sales_Invoice_Navigation}
//                         >
//                             Create Sales Invoice
//                         </Button>
//                     )}




//                     {/* <Button
//                         style={{ gap: '2px' }}
//                         className="createbtn"
//                         iconName="GrCopy"
//                         iconSize={12}
//                     >
//                         Duplicate
//                     </Button> */}
//                     {!deliveryNoteId && deliveryNoteData?.status !== 'Draft' && (
//                         <Button
//                             style={{ gap: '2px' }}
//                             className="custom-btn-00989"
//                             iconName="LuFilePlus2"
//                             iconSize={12}
//                             onClick={CreateDelivaryNote}
//                         >
//                             Save
//                         </Button>
//                     )}


//                     {deliveryNoteId && deliveryNoteData?.status !== 'To Bill' && (
//                         <Button
//                             style={{ gap: '2px' }}
//                             className="custom-btn-00989"
//                             iconName="LuFilePlus2"
//                             iconSize={12}
//                             onClick={handleSubmit}
//                         >
//                             Submit
//                         </Button>
//                     )}



//                     {/* <Button
//                         to="/some-path"
//                         className="px-2"
//                         imgSrc={printerimg}
//                         imgStyle={{ width: '21px' }}
//                     /> */}
//                 </div>
//             </div>
//             <div className="" style={{ width: "100%", overflow: "hidden", backgroundColor: "#fff", flexGrow: '1' }}>
//                 <div className="col-12 p-0" style={{ backgroundColor: '#eff4f9' }}>
//                     <div className="d-flex justify-content-between align-items-end ">
//                         <ul
//                             className="nav nav-tabs mb-0"
//                             style={{ color: "white", border: "none" }}
//                         >
//                             <li className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner">
//                                 <a
//                                     className={tab == 1 ? "nav-link active-tab-custom text-white border-radius-top-corner" : "nav-link nav-link-tab-custom bg-white border-radius-top-corner"}
//                                     onClick={() => { settab(1) }}
//                                     href="javascript:void(0);"
//                                 >
//                                     General Details
//                                     {tab == 1
//                                         ? <GetIcon iconName="MdKeyboardArrowDown" size={15} />
//                                         : <GetIcon iconName="MdKeyboardArrowRight" size={15} />}
//                                 </a>
//                             </li>
//                             <li className="nav-item-tab-custom pb-0 d-flex align-items-end border-radius-top-corner"  >
//                                 <a className={tab == 2 ? "nav-link active-tab-custom text-white border-radius-top-corner" : "nav-link nav-link-tab-custom bg-white border-radius-top-corner"} onClick={() => { settab(2) }} href="javascript:void(0);">
//                                     Address & Contact {tab == 2 ? <GetIcon iconName="MdKeyboardArrowDown" size={15} /> : <GetIcon iconName="MdKeyboardArrowRight" size={15} />}
//                                 </a>
//                             </li>
//                             <li className="nav-item-tab-custom pb-0 d-flex align-items-end border-radius-top-corner"  >
//                                 <a className={tab == 3 ? "nav-link active-tab-custom text-white border-radius-top-corner" : "nav-link nav-link-tab-custom bg-white border-radius-top-corner"} onClick={() => { settab(3) }} href="javascript:void(0);">
//                                     Shipment {tab == 3 ? <GetIcon iconName="MdKeyboardArrowDown" size={15} /> : <GetIcon iconName="MdKeyboardArrowRight" size={15} />}
//                                 </a>
//                             </li>

//                         </ul>
//                         {/* <div className="d-flex align-items-center mb-2 px-3" style={{ gap: "2px", fontSize: '12px' }}>
//                             <span style={{ position: 'relative', top: '-1px' }}>
//                                 <GetIcon iconName="CgAttachment" size={12} />
//                             </span>
//                             <span className=" fw-semibold" style={{ color: "#391F84" }}>
//                                 Attachments
//                             </span>
//                         </div> */}
//                         {(deliveryNoteId || idFromLocalStorage) && <Attachment doctype="Delivery Note"  docname={deliveryNoteId || idFromLocalStorage}  /> }
//                     </div>
//                 </div>
//                 <div className="row d-flex justify-content-between" style={{ marginTop: '14px' }}>
//                     <div className="col-3 " style={{ visibility: tab == 1 ? "visible" : 'hidden', height: tab == 1 ? "auto" : '0px' }}>
//                         {console.log("check delivery note is here here deliveryNoteDatadeliveryNoteData",deliveryNoteData)}
//                         <Tab1 detail={{
//                             picklist,
//                             selectedpicklist,
//                             setselectedpicklist
//                         }} 
//                         postcheckbox={{setpostcheckbox,postcheckbox}}
//                         postdeliverytime={{setpostdeliverytime,postdeliverytime}}
//                         postdeliverydate={{setpostdeliverydate,postdeliverydate}}
//                         deliveryNoteData={deliveryNoteData} activityboll={activityboll} />
//                     </div>
//                     <div className="col-9" style={{ visibility: tab == 1 ? "visible" : 'hidden', height: tab == 1 ? "auto" : '0px' }}>
//                         <div className="d-flex pb-2" style={{ gap: '5px' }}>
//                             <p className="NoOfLine">No. of lines - <span style={{ color: '#2563EB' }}>{deliveryNoteItems?.length}</span></p>
//                             <p className="TotalQty"> Picked Quantity -  {totalPickedQty > 0 ? (
//                                 <span style={{ color: '#16A34A' }}>{totalPickedQty}</span>
//                             ) : 0}
//                             </p>
//                             {/* <p className="ReceivedQty">pick quantity-  <span style={{ color: '#D9FFE5' }}> {deliveryNoteData?.total_qty}</span></p> */}
//                         </div>
//                         <div className="tableLabel">
//                             <div style={{ width: '98.5%', borderBottom: '1px solid #caced3', marginBottom: '6px' }}></div>
//                             <p style={{ color: "#1E1E1E", fontWeight: '500', marginBottom: '4px' }}>
//                                 Item Details
//                             </p>
//                         </div>
//                         <Table deliveryNoteItems={deliveryNoteItems} status={deliveryNoteData?.status} />
//                     </div>
//                     <div className="col-12" style={{ visibility: tab == 2 ? "visible" : 'hidden', height: tab == 2 ? "auto" : '0px' }}> <Tab2 deliveryNoteData={deliveryNoteData} /> </div>
//                     <div className="col-12" style={{ visibility: tab == 3 ? "visible" : 'hidden', height: tab == 3 ? "auto" : '0px' }}> <Tab5 deliveryNoteData={deliveryNoteData} deliveryNoteItems={shipmentItems} /> </div>
//                     <div className="col-12" style={{ visibility: tab == 4 ? "visible" : 'hidden', height: tab == 4 ? "auto" : '0px' }}> <Tab4 /> </div>
//                 </div>
//             </div>

//             <ApiResponseBox
//                 poptype={ptype}
//                 show={showError}
//                 errorMessage={errorr}
//                 onClose={() => setShowError(false)}
//             />

//         </>
//     )
// }

// export default Deliverynote





import { useState } from 'react'
import GetIcon from "../../../../utils/Icon";
import printerimg from "../../../../assets/print.png"
import Button from "../../../../Core/Button/Button";
import FormLayoutTwo from '../../../../Core/Layout/FormLayoutTwo';
import GeneralDetailsTab1 from './newcomponents/GeneralDetailsTab1';
import Table from './newcomponents/Table';
import Table2 from './newcomponents/Table2';
import TotalBox from './newcomponents/TotalBox';
import AdditionalDiscount from './newcomponents/AdditionalDiscount';
import Tab2Box from './newcomponents/Tab2Box';

function Pick() {
    const [activeTab, setActiveTab] = useState('tab1');
    const [tab1Data, setTab1Data] = useState({
        series: '',
        customer: '',
        date_of_visit: '',
        company: '',
        contact_no: '',
        customer_type: '',
        assigned_to: '',
        help_by:''
    });
    const additionalData = {
        tab1: {
            compnay: [{"name" :'Malabar gold and diamonds'}],
            customer_types: [{"name" :'Regular'},{"name" :'VIP'},{"name" :'Wholesale'}],
            assigned_to:[{"name" :'Akash'},{"name" :'Ajay'},{"name" :'Sooraj'}],
            helped_by: [{"name" :'Megha'},{"name" :'Sulekha'},{"name" :'Rahul'}],
        },

    }; 
    const tabs = [
        { id: 'tab1', label: 'General Details', component: GeneralDetailsTab1 }
    ];
    const updateTab1 = (field, value) => {
        console.log(field, value, "check-one");

        setTab1Data(prev => ({ ...prev, [field]: value }));
    };




    const handleSubmit = () => {
        const allData = {
            basicInfo: tab1Data,
            // companyInfo: tab2Data
        };
        console.log('Submitting:', allData);
    };


const getCurrentTabInfo = () => {
    switch (activeTab) {
        case 'tab1':
            return {
                component: GeneralDetailsTab1,
                data: tab1Data,
                onChange: updateTab1,
                extraData: additionalData.tab1
            };
        
        default:
            return null;
    }
};

    const currentTab = getCurrentTabInfo();
    const CurrentComponent = currentTab?.component;

    return (
        <FormLayoutTwo
            title="New Pick"
            breadcrumbs={[
                { label: "Outbound" },
                {
                    label: "Pick List",
                    url: "/outbound/pick/outboundpick",
                },
            ]}
            status={'New'}
            actionButtons={
                <>
                    
                    <Button
                        className="custom-btn-00989"
                        iconName="LuFilePlus2"
                        onClick={handleSubmit}
                        iconSize={12}
                    >
                        Save
                    </Button>

                

                    <Button
                        to="/brand/create-brand"
                        className="px-2"
                        imgSrc={printerimg}
                        imgStyle={{ width: '21px' }}
                    />
                </>
            }
        >
            <div style={{ width: "100%", overflow: "hidden", backgroundColor: "#fff", flexGrow: '1' }}>


                <div className="col-12 p-0" style={{ backgroundColor: '#eff4f9' }}>
                    <div className="d-flex justify-content-between align-items-end">
                        <ul className="nav nav-tabs" style={{ color: "white", border: "none" }}>
                            {tabs.map((tab) => (
                                <li key={tab.id} className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner">
                                    <a
                                        className={`removeborder234 nav-link ${activeTab === tab.id
                                            ? 'active-tab-custom-new text-white'
                                            : 'tab-inactive-custom'
                                            } border-radius-top-corner`}
                                        onClick={() => setActiveTab(tab.id)}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        {tab.label}
                                        <GetIcon iconName={activeTab === tab.id ? "MdKeyboardArrowDown" : "MdKeyboardArrowRight"}   size={15}    />
                                    </a>
                                </li>
                            ))}
                        </ul>
                        <div className="d-flex align-items-center mb-2 px-3">
                            <GetIcon iconName="CgAttachment" size={12} />
                            <span className="fw-semibold ms-1" style={{ color: "#4b002b",fontSize:'13px' }}>
                                Attachments
                            </span>
                        </div>
                    </div>
                </div>


                <div className=" " style={{background :''}}>
                    <div className="row">
                        <div className="col-12">
                            <div >
                                {CurrentComponent && currentTab && (
                                    <CurrentComponent
                                        formData={currentTab.data}
                                        onFieldChange={currentTab.onChange}
                                        extraData={currentTab.extraData}
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                </div>

                {activeTab == "tab1" && <div className="px-3 mb-3" style={{background :''}}>
                    <div className="row">
                        <div className="col-12">
                            <div >
                                <Table
                                setselected_item_data={[]}
                                rows={[]}
                                setRows={()=>{}}
                                list_data={()=>{}}
                                po_status={""}
                                 />
                            </div>
                        </div>
                    </div>
                </div>}

 {/* {activeTab == "tab1" && <div className="px-3 my-3" style={{background :''}}>
                    <div className="row">
                        <div className="col-4">
                            <TotalBox />
                        </div>
                        <div className="col-4">
                            <AdditionalDiscount />
                        </div>
                    </div>
                </div>} */}


            </div>
        </FormLayoutTwo>
    )
}

export default Pick
